import React from "react";
import { JSONTable } from "@shared/json-table";
import type { ColumnDef } from "@shared/json-table";

type AuthUserRow = {
  id: string;
  email: string | null;
  created_at: string;
  last_sign_in_at: string | null;
  email_confirmed_at: string | null;
  phone: string | null;
  banned_until: string | null;
  raw_user_meta_data: Record<string, unknown> | null;
  raw_app_meta_data: Record<string, unknown> | null;
};

const columns: ColumnDef<AuthUserRow>[] = [
  { id: "id", header: "ID", accessorKey: "id", enableSort: true },
  { id: "email", header: "Email", accessorKey: "email", enableSort: true, filter: { type: "text", placeholder: "user@…" } },
  { id: "created_at", header: "Created", accessorKey: "created_at", enableSort: true, filter: { type: "date" } },
  { id: "last_sign_in_at", header: "Last Sign-In", accessorKey: "last_sign_in_at", enableSort: true, filter: { type: "date" } },
  { id: "email_confirmed_at", header: "Email Confirmed", accessorKey: "email_confirmed_at", enableSort: true, filter: { type: "date" } },
  { id: "phone", header: "Phone", accessorKey: "phone", enableSort: true, filter: { type: "text" } },
  { id: "banned_until", header: "Banned Until", accessorKey: "banned_until", enableSort: true, filter: { type: "date" } },
  { id: "raw_user_meta_data", header: "User Meta", accessorKey: "raw_user_meta_data", cell: () => "{…}" },
  { id: "raw_app_meta_data", header: "App Meta", accessorKey: "raw_app_meta_data", cell: () => "{…}" },
];

export default function UsersPage() {
  return (
    <div className="h-full">
      <JSONTable<AuthUserRow>
        id="admin-users"
        baseUrl="/admin/rest-proxy"
        resource="auth.users"
        select="id,email,created_at,last_sign_in_at,email_confirmed_at,phone,banned_until,raw_user_meta_data,raw_app_meta_data"
        columns={columns}
        globalSearch={{ columns: ["email"], placeholder: "Search by email…" }}
        pageSizeOptions={[10, 20, 50]}
        initialState={{
          pageSize: 20,
          columnVisibility: { raw_user_meta_data: false, raw_app_meta_data: false },
        }}
      />
    </div>
  );
}

